// extracted by mini-css-extract-plugin
export default {"accordinItems":"UserCancerInfo_accordinItems__PxGoP","accordionHeader":"UserCancerInfo_accordionHeader__GEWeg","title":"UserCancerInfo_title__nHXZL"};